'use client';

import { Alert, Button, Typography } from '@mui/material';
import { Iconify } from 'src/components/iconify';
import { themeConfig, ThemeProvider } from 'src/theme';

import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';

import { MotionLazy } from 'src/components/animate/motion-lazy';
import { ProgressBar } from 'src/components/progress-bar';
import { defaultSettings, SettingsDrawer, SettingsProvider } from 'src/components/settings';
import { MainLayout } from 'src/layouts/main';

async function getAppConfig() {
  return {
    cookieSettings: undefined,
    dir: defaultSettings.direction,
  };
}

export default async function MaintenancePage() {
  const appConfig = await getAppConfig();
  return (
    <html lang="en" dir={appConfig.dir} suppressHydrationWarning>
      <body>
        <InitColorSchemeScript
          defaultMode={themeConfig.defaultMode}
          modeStorageKey={themeConfig.modeStorageKey}
          attribute={themeConfig.cssVariables.colorSchemeSelector}
        />

        <SettingsProvider
          cookieSettings={appConfig.cookieSettings}
          defaultSettings={defaultSettings}
        >
          <ThemeProvider
            defaultMode={themeConfig.defaultMode}
            modeStorageKey={themeConfig.modeStorageKey}
          >
            <MotionLazy>
              <ProgressBar />
              <SettingsDrawer defaultSettings={defaultSettings} />
              <MainLayout>
                <div className="min-h-screen flex flex-col items-center justify-center px-4 gap-[24px]">
                  <Iconify
                    width={80}
                    icon="hugeicons:license-maintenance"
                    color={themeConfig.palette.primary.main}
                  />
                  <Typography
                    variant="h3"
                    sx={{
                      backgroundImage: themeConfig.gradient.primary.bold,
                      WebkitBackgroundClip: 'text',
                      color: 'transparent',
                      display: 'inline-block',
                    }}
                  >
                    Sedang dalam Perawatan.
                  </Typography>
                  <Alert
                    icon={<Iconify icon="material-symbols:info-rounded" fontSize="inherit" />}
                    sx={{
                      background: '#00a76f2b',
                    }}
                  >
                    Kami sedang memperbarui sistem untuk memberikan pengalaman yang lebih baik.
                  </Alert>
                  <Typography variant="h6" align="center">
                    Mohon maaf atas ketidaknyamanan ini. Kami akan segera kembali online. Terima
                    kasih atas kesabaran Anda.
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => window.location.reload()}
                    sx={{
                      background: themeConfig.gradient.primary.bold,
                    }}
                  >
                    Segarkan Ulang
                  </Button>
                </div>
              </MainLayout>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </body>
    </html>
  );
}
